// Komorka "Koszt wlasny" w tabeli pozycji kalkulacji.
// Dla pozycji powiazanych z produktem (`productId != null`) pobiera aktualny koszt zakupu
// z cennika i pokazuje labelkę "Aktualny: X zl" gdy rozni się od zapisanego `costNet`.
// To podpowiedz dla handlowca, ze cennik dostawcy się zmienil od czasu zapisu kalkulacji.

import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetSalesCrmProductPurchaseCost } from 'api';

import styles from 'theme/components/containers/TraderClientOfferProductsContainer/CalculationPositionsModal.module.scss';

interface ICalculationPositionCostCellProps {
  clientId: number;
  productId: number | null;
  costNet: number | null;
}

const formatNumber = (value: number | null | undefined): string => {
  if (value == null || Number.isNaN(value)) return '-';
  return new Intl.NumberFormat('pl-PL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

/** Tolerancja porownania dwoch float (grosze, 1 cent). */
const COST_DIFF_TOLERANCE = 0.005;

const CalculationPositionCostCell: FC<ICalculationPositionCostCellProps> = ({
  clientId,
  productId,
  costNet
}) => {
  const { t } = useTranslation();
  const { data } = useGetSalesCrmProductPurchaseCost(clientId, productId);
  const currentCost = data?.purchaseCostNet ?? null;

  const showCurrentLabel =
    productId !== null &&
    productId > 0 &&
    currentCost !== null &&
    costNet !== null &&
    Math.abs(currentCost - costNet) > COST_DIFF_TOLERANCE;

  return (
    <>
      {formatNumber(costNet)}
      {showCurrentLabel && (
        <div className={styles.currentCostLabel}>
          {t('salesCrm.calculation.positions.currentCostLabel', {
            value: formatNumber(currentCost)
          })}
        </div>
      )}
    </>
  );
};

export default CalculationPositionCostCell;
